import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationComponent } from '../pages/navigation/navigation.component';
import { ClockComponent } from '../components/clock/clock.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { NgPipesModule } from 'ngx-pipes';
import { EmployeeLeaveWidgetComponent } from '../components/employee-leave-widget/employee-leave-widget.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { MatCardModule } from '@angular/material';
import { HttpLoaderFactory } from './HttpLoaderFactory';

@NgModule({
    imports: [
        CommonModule,
        NgbModule,
        FormsModule,
        NgPipesModule,
        MatCardModule,
        // TranslateModule.forChild(
        //   {
        //     loader: {
        //       provide: TranslateLoader,
        //       useFactory: HttpLoaderFactory,
        //       deps: [HttpClient]
        //     },
        //     isolate: true
        //   }
        // )
         TranslateModule
     ],
    declarations: [
        NavigationComponent,
        ClockComponent,
        EmployeeLeaveWidgetComponent
    ],
    exports: [
        NavigationComponent,
        ClockComponent,
        EmployeeLeaveWidgetComponent
    ]
})
export class SharedModule {}